"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundStatus = exports.WithdrawStatus = exports.DepositStatus = exports.DWSide = exports.BankType = exports.BankStatus = void 0;
var BankStatus;
(function (BankStatus) {
    BankStatus["logged"] = "LOGGED";
    BankStatus["approved"] = "APPROVED";
    BankStatus["rejected"] = "REJECTED";
})(BankStatus = exports.BankStatus || (exports.BankStatus = {}));
var BankType;
(function (BankType) {
    BankType["ABA"] = "aba";
    BankType["IBAN"] = "iban";
    BankType["SWIFT"] = "swift";
})(BankType = exports.BankType || (exports.BankType = {}));
var DWSide;
(function (DWSide) {
    DWSide["DEPOSIT"] = "DEPOSIT";
    DWSide["WITHDRAW"] = "WITHDRAW";
    DWSide["REFUND"] = "REFUND";
})(DWSide = exports.DWSide || (exports.DWSide = {}));
var DepositStatus;
(function (DepositStatus) {
    DepositStatus["NOTIFIED"] = "NOTIFIED";
    DepositStatus["RECEIVED"] = "RECEIVED";
    DepositStatus["CONFIRMED"] = "CONFIRMED";
    DepositStatus["ABNORMAL"] = "ABNORMAL";
    DepositStatus["REFUND"] = "REFUND";
})(DepositStatus = exports.DepositStatus || (exports.DepositStatus = {}));
var WithdrawStatus;
(function (WithdrawStatus) {
    WithdrawStatus["APPLIED"] = "APPLIED";
    WithdrawStatus["APPROVED"] = "APPROVED";
    WithdrawStatus["SHORTAGE"] = "SHORTAGE";
    WithdrawStatus["REJECTED"] = "REJECTED";
    WithdrawStatus["REMITTED"] = "REMITTED";
    WithdrawStatus["FINISHED"] = "FINISHED";
    WithdrawStatus["CANCELED"] = "CANCELED";
    WithdrawStatus["FAILED"] = "FAILED";
})(WithdrawStatus = exports.WithdrawStatus || (exports.WithdrawStatus = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["REMITTED"] = "REMITTED";
    RefundStatus["FINISHED"] = "FINISHED";
    RefundStatus["CANCELED"] = "CANCELED";
    RefundStatus["FAILED"] = "FAILED";
})(RefundStatus = exports.RefundStatus || (exports.RefundStatus = {}));
//# sourceMappingURL=types.js.map